import { ArrowUpward } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useAi } from "src/context/AiContext";
import { useUserData } from "src/context/userContext";

export default function AiLayout_Submit() {
  const { ownerAsiakasId, token } = useUserData();
  const { prompt, isLoading, handleSubmit, setPrompt, response, setResponse, setConversationId } =
    useAi();

  const handleSubmitClick = async () => {
    await handleSubmit(ownerAsiakasId, token);
  };
  const handleClearClick = () => {
    setPrompt("");
    setResponse([]);
    setConversationId(null);
  };

  return (
    <div
      style={{
        padding: 10,
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      }}>
      <Button
        onClick={handleClearClick}
        disabled={isLoading || response.length < 1}
        variant="contained"
        color="primary"
        size="medium"
        type="submit"
        className="center"
        style={{ width: 200 }}>
        TYHJENNÄ
      </Button>
      <div style={{ width: 10 }} />
      <Button
        onClick={handleSubmitClick}
        disabled={prompt.length < 1 || isLoading}
        variant="contained"
        color="primary"
        size="medium"
        type="submit"
        className="center"
        style={{ width: 200 }}>
        <ArrowUpward style={{ opacity: prompt.length > 1 ? 1 : 0, transition: "opacity 0.3s" }} />{" "}
        LÄHETÄ
      </Button>
    </div>
  );
}
